import React, { Fragment} from "react"
import { observer } from "mobx-react"
import { Link } from "react-router-dom"
import Price from "components/Price/Price"
import ProductCount from "components/Product/ProductCount"
import PropTypes from "prop-types"
import ProductRowCartAction from "components/Product/ProductRowCartAction"
import ListActions from "components/Product/ProductRowListAction"
import DropdownQuantities from "components/Product/DropdownQuantities"
import { Label } from "semantic-ui-react";
import shop from "shop/shop"
import OrderModel   from "shop/OrderModel";
import Responsive                                                from "react-responsive"

let orders = []
let ordersWithOpenPositions = []
let openPositions = []
let current = 0
let articleOpen = 0		
//console.log("PRODUCTS ROW: ", shop.cart.products)
const ProductRowDefault = observer( ( { product, onChange, list, cart } ) => {
  let pageSize = 20
  let start = current
  current = current + pageSize
  /*shop.fetch( `/shop/rest/data/orders?start=${start}&count=${pageSize}&open=0` )
    .then( res => {
      console.log( "FROM API", { res } )
      orders = orders.concat( res.values.map( data => new OrderModel( data ) ) )
      openPositions = []
      // find orders with Open Positions
      let orderOpen = orders.filter( order => {
      return order.positions.filter( product => {
        let hasOpen = product.open && product.open !== 0
        if ( hasOpen ) {
        openPositions.push( product )
        console.log("PRODUCT: ",product)
        console.log("OPENPOSITIONS: ",openPositions)
        if(openPositions){
          if(openPositions.length > 0){
            for(let i = 0; openPositions.length > i;i++){
              if(openPositions[i].article_nr == product.article_nr){
                articleOpen = 1
              }
            }
          }
          
        }
        }
        return hasOpen
      } ).length
      } )
      
    } )
    console.log("HASOPEN:", openPositions)
    console.log("HASOPEN:", product.article_nr)
    let articleOpen = 0		
		if(openPositions){
			if(openPositions.length > 0){
				console.log("HASOPEN:", openPositions[0].article_nr)
				console.log("HASOPEN:", product.article_nr)
				for(let i = 0; openPositions.length > i;i++){
					if(openPositions[i].article_nr == product.article_nr){
						console.log("hasopenpassig")
						articleOpen = 1
					}
				}
			}
			
		}*/
    //console.log("pro ",product)
  const hasCustomVE = product.extras.Z_Verpackungseinheit_Anzahl && product.extras.Z_Verpackungseinheit_Anzahl !== "1"
  //console.log("shop.cart.products PRE",shop.cart.data)
  if(Object.keys(product.pinfos).length !== 0){
    if(product.pinfos.brutto){
      //shop.cart.setExtraPositions(product, "couponPrice", (product.pinfos.brutto));
    }
  }
  //console.log("shop.cart.products POST",shop.cart.data)
  return (
    <Fragment>
    <tr>
      <td>
        {cart ? <ProductRowCartAction cart={cart} product={product}/> : null}
      </td>
      <td>
				<Link to={`/product/${product.map_id}`}>
					<img
						className="db center"
            style={{maxWidth: "35px",maxHeight: "35px", minWidth: "35px",minHeight: "35px", overflow: "hidden",objectFit: "contain"}}
						src={product.img_src_small}
						alt=""/>
				</Link>
			</td>
      <td>
        <Link to={`/product/${product.map_id}`}>
          <strong>{product.article_nr}</strong> <br/>
          <span className="product-title">{product.title}</span>
        </Link>
        <p className="f5 fw4 black-50">VE {product.quantities && product.quantities[0] && product.quantities[0].multi ? product.quantities[0].multi : 1} {translate("Stück")}</p>
      </td>
      <td><span className="f6 tc">{product.getNotice( "tiny" )}</span></td>
      { <td>
      {<div className="tr pr2"><span className=" fw6 pb2 tr"><Price>{product.price}</Price></span></div>}
      
        <div className="flex flex-row">
          {/*product.pinfos.gc_rabatt && <div title={translate( "Coupon-Rabatt" )} className="mr1 pb2"><Label size="tiny" className={"giftcardPercent"} color="red"><span className="ttu">-{product.pinfos.gc_rabatt} %</span></Label></div>*/}
          {/*product.pinfos.gc_rabatt && <a title={translate( "Coupon-Rabatt" )} className="labelNeu1">&nbsp;&nbsp;{translate("Coupon:")} {product.pinfos.gc_rabatt} %&nbsp;&nbsp;</a>}
          {/*product.isSale && <div title={translate( "Ihr Kundenrabatt" )} className="pb2"><Label size="tiny" className={"salePercent"} color="red">-{product.salePercent}</Label></div>*/}
          {/*product.isSale && <a className="labelNeu">&nbsp;&nbsp;{translate("Sale!")}&nbsp;&nbsp;</a>*/}
          {product.isSale && product.pinfos.sale_percent && <a className="labelNeu1">&nbsp;&nbsp;{translate("Sale!")}&nbsp;&nbsp;</a>}
          {articleOpen == 1 && <a className="labelNeu">&nbsp;&nbsp;{translate("Rückstand")}&nbsp;&nbsp;</a>}
        </div>
      </td>}
      <td>
        <div><Price>{product.price * (product.quantities && product.quantities[0] && product.quantities[0].multi ? product.quantities[0].multi : 1)}</Price></div>
        <div>{hasCustomVE && <span className={"black-70 f6"}>({product.extras.Z_Verpackungseinheit_Anzahl} {translate("Stück")})</span>} </div>
      </td>
      <td>{console.log("product.count", product)}
        <div>{product.count * (product.quantities && product.quantities[0] && product.quantities[0].multi ? product.quantities[0].multi : 1)} {translate("Stück")}</div>
      </td>
      {/*<td><Price>{product.price * product.unit_multi}</Price></td>*/}
      {/*<td></td>*/}
      { <td>
        <div className="tr">
        {<div><Price>{product.price * product.count * product.unit_multi}</Price></div>}
        </div>
      </td>}
            <td>
        <DropdownQuantities product={product} onChange={onChange}/>
      </td>
      <td className="tr">
        <ProductCount product={product} onChange={onChange}/>
      </td>

      {list && <td>
        <div className="fr"><ListActions list={list} product={product}/></div>
      </td>}
    </tr>
    </Fragment>
  )
} )
export default ProductRowDefault

ProductRowDefault.propTypes = {
  index   : PropTypes.any,
  list    : PropTypes.object,
  cart    : PropTypes.object,
  onChange: PropTypes.func,
  product : PropTypes.any,
}



// WEBPACK FOOTER //
// ./src/theme/fiebiger/components/Product/ProductRowDefault.js